import * as fromUsuarioReducer from './usuario/usuario.reducer';
import { AppStateUsuario } from './usuario';

import * as fromTenantReducer from './operacional-tenant/operacional-tenant.reducer';

import * as fromGruposReducer from './grupo/usuario-grupo.reducer';
import { AppStateGrupos } from './grupo';

import { AppStateUsuarioConfig } from './usuario-config';
import * as fromUsuarioConfigReducer from './usuario-config/usuario-config.reducer';

export interface AppState {
  usuario: AppStateUsuario;
  operacionalTenant: any;
  grupos: AppStateGrupos;
  usuarioConfig: AppStateUsuarioConfig;
}

export const appReducers: any = {
  usuario: fromUsuarioReducer.reducer,
  operacionalTenant: fromTenantReducer.reducer,
  grupos: fromGruposReducer.reducer,
  usuarioConfig: fromUsuarioConfigReducer.reducer,
};

export const selectUsuario = (state: AppState) => state.usuario;
export const selectTenant = (state: AppState) => state.operacionalTenant;
export const selectGruposKeycloak = (state: AppState) => state.grupos;
export const selectUsuarioConfig = (state: AppState) => state.usuarioConfig;
